import { render, staticRenderFns } from "./hcpBindSuccess.vue?vue&type=template&id=8ca5d396&scoped=true"
import script from "./hcpBindSuccess.vue?vue&type=script&lang=js"
export * from "./hcpBindSuccess.vue?vue&type=script&lang=js"
import style0 from "./hcpBindSuccess.vue?vue&type=style&index=0&id=8ca5d396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca5d396",
  null
  
)

export default component.exports